import Vue from 'vue'
import Vuex from 'vuex'
// import custom pathify config (this is optional!)
import pathify from './pathify'

// import helper function
import { make } from 'vuex-pathify'

// setup store
const state = {
  myname: '',
  myprofilepicture: '',
  mystatus: '',
  mybusiness_id: '',
  mysubject: '',
  mytokenroom: '',
  mytokenuser: '',
  myservicename: '',
  mystatusticket: '',
  mystatuslogin: '',
  mystatusroom: '',
  chIsactive: '',
  block_friend: {},
  pathsettings: '',
  socketmessage: {},
  socketquickreply: {},
  socketnote: {},
  socketblock: {},
  socketfriend: {},
  socketaccept_friend: {},
  socketremove_request_friend: {},
  socketremove_friend: {},
  socketcreate_group: {},
  socketinvite_group: {},
  socketactive_group: {},
  socketcencel_group: {},
  socketleave_group: {},
  socketupdate_self: {},
  socketupdate_friend: {},
  socketupdate_img: {},
  socketupdate_file: {}
}

const mutations = make.mutations(state)
// use store
Vue.use(Vuex)

// create store
export default new Vuex.Store({

  // use the plugin
  plugins: [
    pathify.plugin
  ],

  // store properties
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/pathify/store.js